export default __webpack_public_path__ + "static/media/ic_tokens.42432da7.svg";